export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.68 4.167H4.61a.442.442 0 0 0-.443.442v3.1c0 .121.1.22.221.22h.664c.122 0 .221-.099.221-.22V5.272h2.408c.121 0 .221-.1.221-.22v-.665c0-.122-.1-.221-.221-.221zm7.997 7.968h-.664c-.122 0-.221.1-.221.222v2.435h-2.408c-.121 0-.22.1-.22.221v.664c0 .122.099.221.22.221h3.072a.442.442 0 0 0 .442-.442v-3.1c0-.121-.1-.22-.22-.22zm-7.996 2.657H5.273v-2.435c0-.122-.1-.222-.22-.222h-.665c-.122 0-.221.1-.221.222v3.099c0 .245.198.442.442.442h3.072c.121 0 .221-.1.221-.22v-.665c0-.122-.1-.221-.221-.221zm7.775-10.625h-3.072c-.121 0-.22.1-.22.221v.664c0 .122.099.221.22.221h2.408v2.435c0 .122.1.222.221.222h.664c.122 0 .221-.1.221-.222V4.61a.442.442 0 0 0-.442-.442z"
                fill="#FFF"
                fillRule="nonzero"
            />
        </svg>
    );
}
